const logInfo = (message) => {
  console.log(`[INFO]: ${message}`);
};

const logError = (error) => {
  if (error instanceof Error) {
    console.error(`[ERROR]: ${error.message}\nStack: ${error.stack}`);
  } else {
    console.error(`[ERROR]: ${String(error)}`);
  }
};

export {
  logInfo,
  logError,
};